// Newsletter signup (signup.php, a Mailchimp embedded form; replaces Mailchimp's
// mc-validate.js). Submits to Mailchimp's JSONP endpoint (`/subscribe/post-json`;
// it sends no CORS headers, so fetch can't read the answer) and shows the reply
// in the form's #mce-success-response / #mce-error-response boxes.
// Without JavaScript the form still posts to Mailchimp in a new tab.

const TIMEOUT = 10000;

function jsonp(url) {
    return new Promise((resolve, reject) => {
        const callback = `ofNewsletter${Date.now()}${Math.random().toString(36).slice(2)}`;
        const script = document.createElement('script');
        const cleanup = () => {
            delete window[callback];
            script.remove();
            clearTimeout(timer);
        };
        const timer = setTimeout(() => { cleanup(); reject(new Error('timeout')); }, TIMEOUT);
        window[callback] = (data) => { cleanup(); resolve(data); };
        script.onerror = () => { cleanup(); reject(new Error('request failed')); };
        script.src = `${url}&c=${callback}`;
        document.head.append(script);
    });
}

// Mailchimp's messages may contain a link ("… is already subscribed, <a>update
// your profile</a>"): keep text and http(s) links only. Field errors start "0 - ".
function renderMessage(box, html) {
    const doc = new DOMParser().parseFromString(html.replace(/^\d+ - /, ''), 'text/html');
    const nodes = [...doc.body.childNodes].filter((node) => !['SCRIPT', 'STYLE'].includes(node.nodeName)).map((node) => {
        if (node.nodeName === 'A' && /^https?:/.test(node.getAttribute('href') || '')) {
            const a = document.createElement('a');
            a.href = node.getAttribute('href');
            a.target = '_blank';
            a.rel = 'noopener';
            a.textContent = node.textContent;
            return a;
        }
        return document.createTextNode(node.textContent);
    });
    box.replaceChildren(...nodes);
}

function setup(form) {
    const email = form.querySelector('input[name="EMAIL"]');
    const button = form.querySelector('[type="submit"]');
    const success = form.querySelector('#mce-success-response');
    const error = form.querySelector('#mce-error-response');

    const show = (box, message) => {
        [success, error].forEach((b) => { if (b) b.style.display = b === box ? '' : 'none'; });
        if (box) renderMessage(box, message);
    };

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!email.value.trim() || !email.checkValidity()) {
            show(error, form.dataset.msgInvalid);
            email.focus();
            return;
        }

        const url = `${form.action.replace('/subscribe/post?', '/subscribe/post-json?')}&${new URLSearchParams(new FormData(form))}`;
        button.disabled = true;
        try {
            const {result, msg} = await jsonp(url);
            if (result === 'success') {
                show(success, msg);
                form.reset();
            } else {
                show(error, msg || form.dataset.msgFailed);
            }
        } catch {
            show(error, form.dataset.msgFailed);
        } finally {
            button.disabled = false;
        }
    });
}

export default function newsletter() {
    document.querySelectorAll('form[action*="list-manage.com/subscribe/post"]').forEach(setup);
}
